import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { Armour } from '../../types';
import { PopoverItem } from '../../hooks/useItemPopover';

interface MemberArmourProps {
  armours: Armour[];
  onItemClick: (event: React.MouseEvent<HTMLElement>, item: PopoverItem) => void;
}

export const MemberArmour: React.FC<MemberArmourProps> = ({ armours, onItemClick }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          mb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Stack direction="column" spacing={1} alignItems="flex-start">
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
            Armour
          </Typography>
          {armours.length ? (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {armours.map((armour) => (
                <Chip
                  key={armour.id}
                  size="small"
                  label={armour.name}
                  onClick={(event) => onItemClick(event, armour)}
                />
              ))}
            </Box>
          ) : (
            <Typography variant="body2" color="textSecondary">
              None
            </Typography>
          )}
        </Stack>
      </Box>
    </Box>
  );
};
